import { render, staticRenderFns } from "./RessourcesPage.vue?vue&type=template&id=7d1e3007&"
import script from "./RessourcesPage.vue?vue&type=script&lang=js&"
export * from "./RessourcesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports